import { render, staticRenderFns } from "./SerialNumberSearchWidget.vue?vue&type=template&id=4c378e90&"
import script from "./SerialNumberSearchWidget.vue?vue&type=script&lang=js&"
export * from "./SerialNumberSearchWidget.vue?vue&type=script&lang=js&"
import style0 from "./SerialNumberSearchWidget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QSelect,QItem,QItemSection,QInput,QSeparator,QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QSelect,QItem,QItemSection,QInput,QSeparator,QTable,QTr,QTh,QTd})
